import script from "./loadingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./loadingCard.vue?vue&type=script&setup=true&lang=js"

import "./loadingCard.vue?vue&type=style&index=0&id=953a2f72&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-953a2f72"]])

export default __exports__